import {Col, Row} from "react-bootstrap";
import React from "react";
import {GenericSearch} from "../partials/Filter/GenericSearch";

export const filterFields = <Row>
    <Col>
        <GenericSearch/>
    </Col>
</Row>;
